import { Container, Grid, Typography } from '@mui/material';
import { useSearchDirectoryData } from '@/context/searchDirectory/SearchDirectoryDataContext';
import { FAQList } from '@/components/common/FAQList';
import { useResponsive } from '@/components/hooks/useResponsive';
import { getSEOSegmentationFAQs_getSEOSegmentationFAQs_faqList as SEOSegmentationQuestionAnswer } from '@/__generated__/getSEOSegmentationFAQs';

export const FAQSection = () => {
  const pageData = useSearchDirectoryData();
  const { isSmallViewport } = useResponsive();
  const segmentationFAQs = pageData?.getSEOSegmentationFAQs ?? null;
  const faqList = segmentationFAQs?.faqList?.filter(
    (faq): faq is NonNullable<SEOSegmentationQuestionAnswer> => faq !== null
  );

  if (!segmentationFAQs || !faqList) return null;

  const { title } = segmentationFAQs;

  return (
    <Container
      maxWidth="lg"
      sx={{
        my: { xs: 6, md: 10 },
        px: { xl: 0 },
      }}>
      <Grid container item>
        <Grid item md={5}>
          <Typography
            component="h2"
            variant={isSmallViewport ? 'h1' : 'display3'}
            sx={{
              mt: 0,
              maxWidth: { md: '90%', lg: '75%' },
              mb: { xs: 4, sm: 3, md: 0 },
            }}>
            {title}
          </Typography>
        </Grid>
        <Grid item md={7}>
          {faqList && <FAQList faqs={faqList} />}
        </Grid>
      </Grid>
    </Container>
  );
};
